export default __webpack_public_path__ + "static/media/pricing-house-1.2d47c6bf.svg";